
            <p-panel header="{{'login_auth_header' | translate}}">
                <form [formGroup]="loginForm" (submit)="onLogIn()">
                    <app-loader *ngIf="logging"></app-loader>
                    <div style="margin-top:10px;"></div>
                    <div *ngIf="!logging">
                        <span class="ui-float-label">
                            <input type="text" formControlName="email" pInputText style="width:100%" [ngClass]="(email.invalid && (email.dirty || email.touched)) && 'errorMessageBorder'">
                            <label for="float-input">{{'login_login_or_email' | translate}}</label>
                        </span>
                        <div style="margin-top:20px;"></div>
                        <span class="ui-float-label">
                            <input type="password" formControlName="password" pInputText style="width:100%" [ngClass]="(password.invalid && (password.dirty || password.touched)) && 'errorMessageBorder'">
                            <label for="float-input">{{'login_password' | translate}}</label>
                        </span>
                    <div>
                        <div class="ui-g">
                            <div class="ui-g-6 ui-xl-6 ">
                                <div><a routerLink="/forgotpassword">{{'forgot_password' | translate}}</a></div>
                                <div><a routerLink="/register"> {{'login_login' | translate}} >></a>

                                </div>
                            </div>
                        <div class="ui-g-6 ui-xl-6 ui-g-nopad">
                    <div style="text-align: right;margin-top:10px">
                        <button pButton type="submit" label="{{'login' | translate}}" [disabled]="loginForm.invalid" class="ui-button-raised ui-button-success"></button>
                    </div>
                        </div>
                    </div>
                    </div>
                </div>
                </form>
            </p-panel>
